<div class="payment-info-container" class="padding-top-25" *ngIf = "!submitted" [ngClass]="{'modal-content': modalView, 'payment-info-modal': modalView
   }">
  <div *ngIf = "modalView" class="modal-header" >
    <div>Payment Information </div>
    <div class="close-modal-btn" (click)="onNoClick()"></div>
  </div>
  
  <div class="payment-info-text" #modalErrorDiv>
    <div *ngIf = "modalView && transErrorModal" class="error-in-modal" >
      {{transErrorMsg}}
    </div>
    For your convenience, we offer two secure payment options. You may pay by wire transfer or ACH Debit. Please note: The ACH Debit payment method is not available for International applicants. If you are an International applicant you must submit your payment via wire transfer.
    <div class="flex-container" *ngIf="!isFormTypeE()" class="padding-top-25">
      <span>{{formName}}</span>
      <span class="price-disp">${{price | number: '1.2-2'}}</span>
    </div>
    <div *ngIf="isFormTypeE()" class="pmt-padding-top" >
      {{formName}}
      <span class="flex-container">
          <label class="formE-prices formE-inst-text">
            <input type="radio" [(ngModel)]="formEType" value="New" name="formEType" class="radio-style-prices" (ngModelChange)="updateFormEPaymentAmount('New')" >
            Name for a new contact lens material 
          </label>
          <span class="price-disp">${{getPricesFormTypeE('New') | number: '1.2-2'}}</span>
      </span>
      <span class="flex-container">
        <label class="formE-prices">
          <input type="radio" [(ngModel)]="formEType" value="Modified" name="formEType" class="radio-style-prices" (ngModelChange)="updateFormEPaymentAmount('Modified')" >
          <span class="formE-inst-text">USAN modified</span> (name for a contact lens material for which an adopted USAN already exists)
        </label>
        <span class="price-disp">${{getPricesFormTypeE('Modified') | number: '1.2-2'}}</span>
      </span>
      <span class="flex-container">
        <label class="formE-prices">
          <input type="radio" [(ngModel)]="formEType" value="Revised" name="formEType" class="radio-style-prices" (ngModelChange)="updateFormEPaymentAmount('Revised')" >
          <span class="formE-revised-label-container">
            <span class="formE-inst-text" >USAN revised</span>
            <span class="margin-left-10">
            (revision of support information used to define a USAN or USAN modified,<br/> resulting in a revised adoption and/or revised publication) </span>
          </span>
        </label>
        <span class="price-disp">${{getPricesFormTypeE('Revised') | number: '1.2-2'}}</span>
      </span>
    </div>

  </div>
  <div [ngClass]="{'modal-dialog-content' : modalView}">
    <div class="pmt-padding-top pmt-padding-bottom">
        <label class="payment-types">
          <input type="radio" value="ach" name="paymentType" class="radio-style" [(ngModel)]="selectedSection">
          Bank Deposit (ACH Debit)
        </label>
        <div *ngIf="selectedSection === 'ach'" class="section ach-container">
          <span class="flex-container"> 
            <label class="account-type-label">
              Checking
              <input type="radio" value="1" class="radio-style" [(ngModel)]="accountType">
            </label>
            <label class="account-type-label padding-left-50">
              Saving
              <input type="radio" value="0" class="radio-style"  [(ngModel)]="accountType" >
            </label>
         
          </span>
          <div class="ach-info-item-container">
              <div class="ach-pmt-item-input-container">
                <mat-form-field appearance="outline" class="ach-pmt-info-form-field">
                  <mat-label>Account Number</mat-label>
                  <input matInput #accountNumberInput [(ngModel)]="accountNumber" class="ach-pmt-info ach-pmt-info-item-input"
                    (keyup.enter)="updateAccountNumber($event)" (keyup.escape)="cancelAccountNumberUpdate()"
                     (blur)="updateAccountNumber($event)" />
                  <mat-icon matSuffix (mousedown)="clearAccountNumberInputField()">cancel</mat-icon>
                </mat-form-field>
              </div>
              <div *ngIf="accountNumberError" class="error-msg">
                Account number is required.
              </div>
          </div>

          <div class="ach-info-item-container">
              <div class="ach-pmt-item-input-container">
                <mat-form-field appearance="outline" class="ach-pmt-info-form-field">
                  <mat-label>Routing Number</mat-label>
                  <input matInput #routingNumberInput [(ngModel)]="routingNumber" class="ach-pmt-info ach-pmt-info-item-input"
                    (keyup.enter)="updateRoutingNumber($event)"
                    (keyup.escape)="cancelRoutingNumberUpdate()"
                    (blur)="updateRoutingNumber($event)"
                    minlength="9"
                    maxlength="9"
                    />
                  <mat-icon matSuffix (mousedown)="clearRoutingNumberInputField()">cancel</mat-icon>
                </mat-form-field>
              </div>
              <div *ngIf="routingNumberError" class="error-msg">
                Routing number is required.
              </div>
              <div *ngIf="routingNumberLenghtError" class="error-msg">
                Routing number must be exactly 9 characters.
              </div>
              
          </div>
          <!--<div class = "multi-item-row" [ngClass]="{ 'multi-item-row-wide': !isMobileDeviceSize }"> -->
             <div class="ach-info-item-container">
                <div class="ach-pmt-item-input-container">
                    <mat-form-field appearance="outline" class="ach-pmt-info-form-field">
                      <mat-label>Bank Account Holder Name</mat-label>
                      <input matInput #firstNameInput [(ngModel)]="accountName" class="ach-pmt-info ach-pmt-info-item-input"
                            (keyup.enter)="updateAccountName($event)" (keyup.escape)="cancelAccountNameUpdate()" (blur)="updateAccountName($event)" />
                      <mat-icon matSuffix (mousedown)="clearAccountNameInputField()">cancel</mat-icon>
                    </mat-form-field>
                </div>
                <div *ngIf="accountNameBlankError" class="error-msg">
                  Account Name is required.
                </div>
                <div *ngIf="accountNameLengthError" class="error-msg">
                  Account Name must be fewer than 30 characters
                </div>
              </div>
          <!--</div>  -->
           <!-- Street 1  -->
            <div class="ach-info-item-container" >
                <div class="ach-pmt-item-input-container">
                  <mat-form-field appearance="outline" class="ach-pmt-info-form-field">
                    <mat-label>Address</mat-label>
                    <input matInput #street1Input [(ngModel)]="street1" class="ach-pmt-info ach-pmt-info-item-input"
                      (keyup.enter)="updateStreet1($event)" (keyup.escape)="cancelStreet1Update()" (blur)="updateStreet1($event)" />
                    <mat-icon matSuffix (mousedown)="clearStreet1InputField()">cancel</mat-icon>
                  </mat-form-field>
                </div>
                <div *ngIf="street1Error" class="error-msg">
                  Address is required.
                </div>
            </div>
            

          <!-- Street 2  -->
          <div class="ach-info-item-container">
              <div class="ach-pmt-item-input-container">
                <mat-form-field appearance="outline" class="ach-pmt-info-form-field">
                  <mat-label>Address 2 (Optional)</mat-label>
                  <input matInput #street2Input [(ngModel)]="street2" class="ach-pmt-info ach-pmt-info-item-input"
                    (keyup.enter)="updateStreet2($event)" (keyup.escape)="cancelStreet2Update()" (blur)="updateStreet2($event)" />
                  <mat-icon matSuffix (mousedown)="clearStreet2InputField()">cancel</mat-icon>
                </mat-form-field>
              </div>
          </div>
              <!-- City  -->
          <div class="ach-info-item-container" >
              <div class="ach-pmt-item-input-container">
                <mat-form-field appearance="outline" class="ach-pmt-info-form-field">
                  <mat-label>City</mat-label>
                   <input matInput #cityInput [(ngModel)]="city" class="ach-pmt-info ach-pmt-info-item-input"
                      (keyup.enter)="updateCity($event)" (keyup.escape)="cancelCityUpdate()" (blur)="updateCity($event)" />
                    <mat-icon matSuffix (mousedown)="clearCityInputField()">cancel</mat-icon>
                </mat-form-field>
              </div>
              <div *ngIf="cityError" class="error-msg">
                  City is required.
              </div>
          </div>

          <div class = "multi-item-row" [ngClass]="{ 'multi-item-row-wide': !isMobileDeviceSize }">
            <!-- State  -->
            <div class="ach-info-item-container">
                <div class="ach-pmt-item-input-container">
                  <mat-form-field class="ach-pmt-info-form-field">
                    <mat-label>State</mat-label>
                      <mat-select [(value)]="state">
                        <ng-container  *ngFor="let s of states">
                          <mat-option [value]="s.key" class="ach-pmt-info-select-item">{{ s.value }}</mat-option>
                        </ng-container>
                      </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="stateError" class="error-msg">
                  State is required.
                </div>
            </div>
            <!-- ZipCode  -->
            <div class="ach-info-item-container">
                  <div class="ach-pmt-item-input-container">
                    <mat-form-field appearance="outline" class="ach-pmt-info-form-field">
                      <mat-label>Zip Code</mat-label>
                      <input matInput #zipCodeInput [(ngModel)]="zipCode" class="ach-pmt-info ach-pmt-info-item-input"
                        (keyup.enter)="updateZipCode($event)" (keyup.escape)="cancelZipCodeUpdate()" (blur)="updateZipCode($event)" />
                      <mat-icon matSuffix (mousedown)="clearZipCodeInputField()">cancel</mat-icon>
                    </mat-form-field>
                  </div>
                  <div *ngIf="zipCodeError" class="error-msg">
                    5 digit Zip Code is required.
                  </div>
              </div>
          </div>
          <div>
              <input type="checkbox" class="checkbox-style" 
                     name="agreeTerms" [(ngModel)]="agreeTerms" 
                     [ngClass]="{ 'checkbox-error': agreeTermsError }" >
               I hereby authorize this merchant to electronically debit the bank account 
               I have entered for the amount specified. I acknowledge that the origination of ACH (US) /EFT (Canada) transactions to my account must comply with the provisions of the North America law.
               I will not dispute any charges debiting my checking/saving account, so long as the transaction corresponds to the terms indicated in this web form.
               <div *ngIf="agreeTermsError" class="error-msg-agree">
                <p>Please accept the terms.</p>
              </div>
           </div>
            <div class="submit-button-container">
              <button type="button" class="step-btn form-step-btn form-step-btn-style form-step-btn-text" 
                [ngClass]="isMobileDeviceSize ? 'form-step-btn__mobile' : 'form-step-btn__full'" (click)="submitPayment()">
                  Submit Payment
               </button>
            </div>
    
        </div>
        <br/>
        <label class="payment-types">
          <input type="radio" value="wire" name="paymentType"  class="radio-style" [(ngModel)]="selectedSection">
          Wire Transfer
        </label><br>
        <div *ngIf="selectedSection === 'wire'" class="section section-wire">
          <p>
            <span style="font-weight: 500;">Wire Transfer Instructions for AMA</span><br/>
            The Northern Trust Company<br/>
            50 South La Salle Street<br/>
            Chicago, IL 60675<br/>
            ABA #071000152<br/>
            Swift #: CNORUS44 (if needed for international transfers)<br/>
            Account Number: 54070<br/>
            Account Name: AMA General Checking Account<br/>
            Descriptor: Please add your case ID for this application ({{caseNumber}}) to the payment description of your wire transfer
          </p>
          <p>
            Once you have a proof a payment, please enter payment date and upload using the field below.
          </p>
          <app-proof-of-payment [paymentAmount]="amountForUpload" [isModal]="modalView"></app-proof-of-payment>
        </div>

      
    </div>
  </div>
</div>

<div class="payment-success-message" *ngIf = "submitted" [ngClass]="{'modal-content': modalView, 'payment-info-modal': modalView}">
  Payment was successful. Transaction ID: {{transId}}.
  <span *ngIf = "!modalView"> Please click the 'Continue' button to proceed. </span>
  <span *ngIf = "modalView"><br/>
    <div class="success-in-modal submit-button-container[">
      <button type="button" class="width-100 step-btn form-step-btn form-step-btn-style form-step-btn-text" 
         (click)="onNoClickWithStatus()">
          Close
      </button>
    </div>
  </span>
</div>